<div class="off-canvas-content">
  <div class="offCanvas__container">
    <div class="offCanvas__contentWrapper">
      <div class="offCanvas__header">
        <div class="offCanvas__title">
          Scan Document
        </div>
        <img (click)="onCloseIconClick()" class="offCanvas__crossIcon"
          src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon" />
        </div>
        @if(companyPrefs?.documentVault?.scanner && !companyPrefs?.['sdex-scanner']?.enabled){
        <div appAccessControl allowedModules="documentVault.scanner" allowedRoles="mr-outbound.upload,mr-inbound.upload,mr-scrap.upload">
          @if(!bStartUp){
          <app-dwt [events]="eventsSubject.asObservable()" (closePopupEvent)="onCloseIconClick()"></app-dwt>
          }
        </div>
        }
        @if(companyPrefs?.['sdex-scanner']?.enabled){
        <div appAccessControl allowedModules="sdex-scanner.enabled">
          <app-open-scan (closeEvent)="onCloseIconClick()"></app-open-scan>
        </div>
        }
      </div>
    </div>
  </div>